<template>
  <div class="accountList">
    <van-tabs
      v-show="state"
      v-model="state"
      @change="stateChanged"
      title-active-color="#ffffff"
      title-inactive-color="#666666"
      color="#1b347c"
      swipeable
      :ellipsis="false"
      type="card"
    >
      <van-tab
        v-for="(menu, index) in stateList"
        :key="index"
        :title="menu.text"
        :name="menu.value"
      >
        <div class="amount-header" v-if="menu.value == state && stateList.length > 0">
          <div class="amount-label">{{ $t.accountList.accountBalance }}</div>
          <div class="amount-value">
            <span class="symbol">{{ menu.CurrencySymbol }}</span> {{ menu.TotalAmount }}
          </div>
        </div>

        <search-top
          @changeOrderBy="changeOrderBy"
          @handleInput="handleInput"
          :orderBy="orderBy"
          :isFilter="checkFilter()"
        ></search-top>

        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="firstLoad(page + 1)"
        >
          <div
            class="detail"
            v-for="(detail, index) in tableData"
            :key="index"
            @click="gotoPayBillList(detail.FundType, detail.SystemOperationNumber)"
          >
            <div class="logo">
              <div
                class="circle"
                :style="{
                  background:
                    detail.FundType == 1 || detail.FundType == 3 ? '#c6f8e3' : '#ffdee0',
                }"
              ></div>
            </div>
            <div class="left">
              <div class="fundType">
                <span v-if="detail.FundType == 1">{{ $t.accountList.fundType1 }}</span>
                <span v-if="detail.FundType == 2">{{ $t.accountList.fundType2 }}</span>
                <span v-if="detail.FundType == 3">{{ $t.accountList.fundType3 }}</span>
                <span v-if="detail.FundType == 4">{{ $t.accountList.fundType4 }}</span>
              </div>
              <div class="flowDate">{{ detail.FlowDate }}</div>
            </div>
            <div class="right">
              <div
                :class="[
                  'bookAmount',
                  detail.FundType == 1 || detail.FundType == 3 ? 'green' : 'red',
                ]"
              >
                <span v-if="detail.BookkeepingAmountStr">{{
                  detail.BookkeepingAmountStr
                }}</span>
                <span v-else>{{ detail.BookkeepingAmount }}</span>
              </div>
              <div class="bookBalance">
                {{ detail.CurrencySn }} {{ $t.accountList.balance }}：{{
                  detail.BookkeepingAccountBalanceStr
                }}
              </div>
            </div>
            <div class="arrow">
              <van-icon name="arrow" v-if="detail.FundType == 2" />
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.accountList.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.accountList.fundTypeStr }}</div>
        <van-radio-group v-model="searchOption" direction="horizontal">
          <van-radio name="1">{{ $t.accountList.fundType1 }}</van-radio>
          <van-radio name="2">{{ $t.accountList.fundType2 }}</van-radio>
          <van-radio name="3">{{ $t.accountList.fundType3 }}</van-radio>
          <van-radio name="4">{{ $t.accountList.fundType4 }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.accountList.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.accountList.confirm
        }}</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Col,
  Row,
  List,
  Popup,
  Form,
  Button,
  Radio,
  RadioGroup,
  Icon,
  Tab,
  Tabs,
} from "vant";
import SearchTop from "./components/SearchTop";

Vue.use(Col)
  .use(Row)
  .use(List)
  .use(Popup)
  .use(Form)
  .use(Button)
  .use(Radio)
  .use(RadioGroup)
  .use(Icon)
  .use(Tab)
  .use(Tabs);

export default {
  name: "accountList",
  components: {
    SearchTop,
  },
  data() {
    return {
      state: null,
      stateList: [],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //筛选
      orderBy: "",
      searchText: "",
      searchOption: null,
      showFilter: false,
    };
  },
  watch: {
    state() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  mounted() {
    this.getCurrencyList();
  },
  methods: {
    gotoPayBillList(type, id) {
      if (type == 2) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "paybillList",
          name: "paybillList",
          query: [
            {
              name: "NuclearAccountNo",
              value: id,
            },
          ],
        });
      }
    },
    checkFilter() {
      if (this.searchOption) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchOption = null;
      this.$bus.$emit("clearAccountListSearch", true);
      this.initList();
      this.changeOrderBy({ orderBy: this.orderBy });
    },
    filterSubmit() {
      this.initList();
      this.changeOrderBy({ orderBy: this.orderBy });
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    handleInput(text) {
      this.searchText = text;
    },
    changeOrderBy(data) {
      if (data.orderBy == 2) {
        this.showFilter = true;
        return;
      }
      window.scrollTo({
        top: 0,
      });
      if (data.orderBy) {
        this.orderBy = data.orderBy;
      }
      if (data.text) {
        this.searchText = data.text;
      }
      if (data.action) {
        this.searchOption = data.action.value;
      }
      this.initList();
      this.getList(1);
    },
    firstLoad(page) {
      this.getList(page);
    },
    stateChanged(state) {
      this.state = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.account
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
                CurrencySymbol: item.CurrencySymbol,
                TotalAmount: 0,
              };
              result.push(data);
            });
            this.state = result[0].value;
            this.stateList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getList(page) {
      var param = {
        SCId: this.state,
        PageIndex: page,
        PageSize: this.pageSize,
        IsEliminateWriteOffRecords: 1,
        FundType: this.searchOption,
      };
      return new Promise((resolve) => {
        this.$api.account
          .getCustomerFundUseDetailAndAvailableFundList(param)
          .then((res) => {
            if (this.state) {
              var fund = res.data.AvailableFundList.find((a) => a.SCId == this.state);
              for (var state of this.stateList) {
                if (state.value == fund.SCId) {
                  state.TotalAmount = fund.TotalAmount;
                }
              }
            }
            var detail = res.data.UseDetailList;
            this.tableData = this.tableData.concat(detail.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = detail.PageIndexs;
            this.finished = this.page >= detail.ALLPages;
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.accountList {
  .van-tabs {
    ::v-deep .van-tabs__wrap {
      height: auto;
    }
    ::v-deep .van-tabs__nav {
      margin: 10px;
      border-radius: 10px;
      height: 45px;
      border-color: #e4e9f0 !important;
      background-color: #f8f9fe;
      .van-tab--active {
        box-shadow: 0px 2.5px 6.5px 1px rgb(0 0 0 / 10%);
      }
      .van-tab {
        margin: 5px;
        border: none;
        border-radius: 10px;
      }
    }
  }
  .amount-header {
    margin: 0px 10px 10px 10px;
    padding: 15px;
    font-size: 14px;
    border: 1px solid #e5e5e5;
    background: white;
    box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    .amount-label {
      color: #666666;
      font-size: 14px;
      font-weight: 500;
    }
    .amount-value {
      margin-top: 10px;
      font-size: 20px;
      font-weight: 500;
      .symbol {
        font-size: 12px !important;
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
    ::v-deep .van-radio__icon--checked {
      .van-icon-success {
        background-color: #2750aa !important;
        border-color: #2750aa !important;
      }
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
  }
  .popup-footer {
    position: fixed;
    bottom: calc(0px + env(safe-area-inset-bottom));
    width: 100%;
    text-align: center;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .van-pull-refresh {
    overflow: unset;
  }
  .list {
    .detail {
      margin: 10px;
      background: #fff;
      padding: 15px 0px 15px 0px;
      border-radius: 10px;
      border: 1px solid #e5e5e5;
      box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
      .logo {
        vertical-align: middle;
        display: inline-block;
        width: 20%;
        .circle {
          width: 45px;
          height: 45px;
          margin: auto;
          border-radius: 100px;
        }
      }
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        .fundType {
          color: #000;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 5px;
        }
        .flowDate {
          color: #999;
          font-size: 12px;
        }
      }
      .right {
        text-align: right;
        vertical-align: middle;
        display: inline-block;
        width: 35%;
        .bookAmount {
          color: #333;
          font-size: 14px;
          margin-bottom: 5px;
        }
        .green {
          color: #00ae61;
        }
        .red {
          color: #ff454c;
        }
        .bookBalance {
          color: #999;
          font-size: 12px;
        }
      }
      .arrow {
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        width: 5%;
        .van-icon {
          font-size: 10px;
          font-weight: bold;
          color: #999;
        }
      }
    }
  }
}
</style>
